import { useContext, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import ChatOptionsIcon from '../../assets/icon-chat-options.svg?react';
import DocumentIcon from '../../assets/icon-google-document.svg?react';
import PrivateChatIcon from '../../assets/icon-private-chat.svg?react';
import SavedPromptsIcon from '../../assets/icon-bookmark.svg?react';
import PaperclipIcon from '../../assets/icon-paperclip.svg?react';
import ModelSelectIcon from '../../assets/icon-change-mdel.svg?react';
import LanguageSelectIcon from '../../assets/icon-language.svg?react';
import PromptHelperIcon from '@/assets/icon-prompt-helper.svg?react';
import FiannceAppIcon from '@/assets/icon-finance-app.svg?react';
import { SettingContext } from '@/context/SettingContext';
import useElysiaStore from '@/app/elysia-store';
interface ChatWidgetProps {
  OnTogglePrivateChat: () => void;
  onAddSources: () => void;
  onInitiatedSavedPrompts: (boolean) => void;
  onAttachFileClick: () => void;
  onInitiatedModelSelect: (boolean) => void;
  onInititatedLanguageSelect: (boolean) => void;
  onInitiatedBrandAgentSelect: (boolean) => void;
  onInitiatedPromptHelper: (boolean) => void;
  onoInitiatedFinanceModal: (boolean) => void;
}

export const ChatWidgets = ({
  OnTogglePrivateChat,
  onAddSources,
  onInitiatedSavedPrompts,
  onAttachFileClick,
  onInitiatedModelSelect,
  onInititatedLanguageSelect,
  onInitiatedPromptHelper,
  onoInitiatedFinanceModal,
}: ChatWidgetProps) => {
  const [show, setShow] = useState(false);
  const { selectedLanguage, defaultLanguage, selectedModel, defaultModel } =
    useContext(SettingContext);
  const isPrivateChat = useElysiaStore((state) => state.isPrivateChat);
  const chatAgent = useElysiaStore((state) => state.chatAgent);
  const isChatDisabled = useElysiaStore((state) => state.isChatDisabled);
  const isPreview = useElysiaStore((state) => state.isPreview);
  const isAppPreview = useElysiaStore((state) => state.isAppPreview);
  const promptToolsConfig = useElysiaStore((state) => state.promptToolsConfig);

  const toggleMenu = () => setShow(!show);

  return (
    <>
      <Dropdown show={show} onToggle={toggleMenu} drop="up">
        <Dropdown.Toggle
          variant="light"
          id="chat-widget-dropdown"
          className={`d-block d-md-none chat-widgets ${isChatDisabled ? 'disable-prompt' : ''}`}
        >
          <ChatOptionsIcon />
        </Dropdown.Toggle>

        <Dropdown.Menu className="d-md-none">
          {!isAppPreview && !isPreview && promptToolsConfig.privateChat && (
            <Dropdown.Item as="button" onClick={OnTogglePrivateChat} active={isPrivateChat}>
              <PrivateChatIcon />
              Private chat
            </Dropdown.Item>
          )}
          {promptToolsConfig.attachFiles && (
            <Dropdown.Item as="button" onClick={onAttachFileClick}>
              <PaperclipIcon />
              Attach file
            </Dropdown.Item>
          )}
          {promptToolsConfig.addSources && (
            <Dropdown.Item
              as="button"
              aria-label="Add sources"
              onClick={onAddSources}
              active={chatAgent === 'Document'}
            >
              <DocumentIcon />
              Add sources
            </Dropdown.Item>
          )}
          {!isPrivateChat && promptToolsConfig.savedPrompts && (
            <Dropdown.Item as="button" onClick={onInitiatedSavedPrompts} aria-label="Saved prompts">
              <SavedPromptsIcon />
              Saved prompts
            </Dropdown.Item>
          )}
          {promptToolsConfig.changeModel && (
            <Dropdown.Item
              as="button"
              onClick={onInitiatedModelSelect}
              active={selectedModel?.name_of_model !== defaultModel?.name_of_model}
            >
              <ModelSelectIcon />
              Change Model
            </Dropdown.Item>
          )}
          {promptToolsConfig.changeLanguage && (
            <Dropdown.Item
              as="button"
              onClick={() => onInititatedLanguageSelect(true)}
              active={selectedLanguage !== defaultLanguage}
              aria-label="Prompt Improver"
            >
              <LanguageSelectIcon />
              Change Language
            </Dropdown.Item>
          )}
          {promptToolsConfig.promptImprover && (
            <Dropdown.Item as="button" onClick={onInitiatedPromptHelper}>
              <PromptHelperIcon />
              Prompt Improver
            </Dropdown.Item>
          )}
          {promptToolsConfig.configFinance && (
            <Dropdown.Item as="button" onClick={onoInitiatedFinanceModal}>
              <FiannceAppIcon />
              Selections
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};
